document.addEventListener("DOMContentLoaded", function () {
  // if (window.innerWidth < 768) {
    const paragraphs = document.querySelectorAll('.footer__block--links div p');
    
    paragraphs.forEach(function (p) {
        p.addEventListener('click', function () {
            this.classList.toggle('active');

        const ul = this.parentElement.querySelector('ul');
        if (!ul) return;

        if (ul.style.maxHeight && ul.style.maxHeight !== '0px') {
          ul.style.maxHeight = '0px';
        } else {
          ul.style.maxHeight = ul.scrollHeight + 'px';
        }
      });
    });
  // }
});